export const methods = {
  //iOS 回上一頁空白修正
  appleDebug() {
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  },

  // 點擊開關class
  // clickToggleClass(點擊目標,加上cls名稱)
  clickToggleClass(target, className) {
    $(target).on('click', function () {
      $(this).toggleClass(className);
    })
  },

  // 點擊切換active
  // clickSwitchClass(點擊目標,加上cls名稱)
  lickSwitchClass(target, className) {
    $(target).on('click', function () {
      $(target).not(this).removeClass(className);
      $(this).addClass(className);
    })
  },

  // 倒數計時
  // 搭配以下結構使用
  // .countdown(data-seconds="600")  data-seconds 填入欲倒數秒數
  // clearInterval(interval) 可以暫停
  countDown() {
    $('.countdown').html('');
    const set_seconds = Number($('.countdown').attr('data-seconds')) + 1;
    let set_time = Math.floor(set_seconds / 60) + ':' + set_seconds % 60;
    window._common.interval = setInterval(function () {
      var timer = set_time.split(':');
      var minutes = parseInt(timer[0], 10);
      var seconds = parseInt(timer[1], 10);
      --seconds;
      minutes = (seconds < 0) ? --minutes : minutes;
      minutes = (minutes < 10) ? minutes = '0' + minutes : minutes;
      if (minutes == 0 && seconds == 0) clearInterval(window._common.interval);
      seconds = (seconds < 0) ? 59 : seconds;
      seconds = (seconds < 10) ? '0' + seconds : seconds;
      $('.countdown').html(minutes + ':' + seconds);
      set_time = minutes + ':' + seconds;
    }, 1000);
  },

  // clearInterval(_common.interval[?]) 可以暫停
  // countDown() {
  //   window._common.interval = []
  //   const countdowns = $('.countdown')
  //   countdowns.each((i, el) => {
  //     const set_seconds = Number($(el).attr('data-seconds')) + 1;
  //     let set_time = Math.floor(set_seconds / 60) + ':' + set_seconds % 60;
  //     window._common.interval[i] = setInterval(function () {
  //       var timer = set_time.split(':');
  //       var minutes = parseInt(timer[0], 10);
  //       var seconds = parseInt(timer[1], 10);
  //       --seconds;
  //       minutes = (seconds < 0) ? --minutes : minutes;
  //       minutes = (minutes < 10) ? minutes = '0' + minutes : minutes;
  //       if (minutes == 0 && seconds == 0) clearInterval(window._common.interval[i]);
  //       seconds = (seconds < 0) ? 59 : seconds;
  //       seconds = (seconds < 10) ? '0' + seconds : seconds;
  //       $(el).html(minutes + ':' + seconds);
  //       set_time = minutes + ':' + seconds;
  //     }, 1000);
  //   })
  // },

  // 複製網址
  // el => 點擊的對象
  // text => 想要顯示的文字
  // 使用範例 common.copylink('.xxx','Copied 您已成功複製連結')
  // css在 sass/base/_common 要改樣式可以進去改
  copyUrl(el, text, top) {
    let notice = `<div class='notice-wrapper ${top ? 'top' : ''}'><div class='text'> ${text} </div><input id='clipboard' type='text' readonly></div>`
    $(el).on('click', function () {
      $('body').append(notice)
      if ($(notice).length > 0) {
        let url = window.location.href
        let clipboard = $('#clipboard')
        let offset = $(this).offset()
        let elWidth = $(this).innerWidth() / 2
        $('.notice-wrapper').css({
          'top': offset.top,
          'left': offset.left + elWidth,
        }).show()
        clipboard.val(url);
        clipboard[0].setSelectionRange(0, 9999);
        clipboard.select();
        if (document.execCommand('copy')) {
          document.execCommand('copy');
          $('.notice-wrapper .text').fadeIn(300).promise().done(function () {
            setTimeout(function () {
              $('.notice-wrapper .text').fadeOut(300).promise().done(function () {
                $('.notice-wrapper').remove()
              })
            }, 1500)
          });
        }
      }
    })
  },

  // 計算手機100vh
  fixMobile100vh() {
    const init = function () {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', vh + 'px')
    }
    init()
    $(window).on('resize', function () {
      init()
    })
  },

  // 文字切割
  // target(String) => 目標物件('.xxx')
  // isWrap => 是否要每個單字再包一層
  // delayStartTime(Number) => 第一個的延遲時間(若為'random'則隨機)
  // delaySpace(Number) => 每一個字元延遲的間隔時間
  // randomTransTime => 隨機transition Max time
  wordAnimation(target, isWrap, delayStartTime, delaySpace, randomTransTime) {
    const word = $(target).html()
    const removeBr = word.split('<br>')
    let newText = ''
    let index = 0
    removeBr.forEach((words, s) => {
      if (s !== 0) newText += `<br>`
      const letters = words.split('')
      letters.forEach((letter, i) => {
        if (isWrap) {
          if (i === 0) newText += `<span class="letter-wrap" style="display: inline-block">`
          if (letter === ' ') newText += '<span class="letter" style="display: inline-block;">&nbsp;</span>'
          else {
            newText += `<span class="letter"${randomTransTime || delayStartTime ? ` style="${randomTransTime ? `transition: ${methods.formatFloat(Math.random(), 2) * randomTransTime}s;` : ''}${delayStartTime ? delayStartTime === 'random' ? `transition-delay: ${methods.formatFloat(Math.random(), 2)}s;` : `transition-delay: ${delayStartTime + index * delaySpace}s;` : ''}"` : ''}>${letter}</span>`
            index ++
          }
          if (i === words.length - 1) newText += `</span>`
        }
        else {
          if (letter === ' ') newText += '<span class="letter" style="display: inline-block;">&nbsp;</span>'
          else {
            newText += `<span class="letter"${randomTransTime || delayStartTime ? ` style="${randomTransTime ? `transition: ${methods.formatFloat(Math.random(), 2) * randomTransTime}s;` : ''}${delayStartTime ? delayStartTime === 'random' ? `transition-delay: ${methods.formatFloat(Math.random(), 2)}s;` : `transition-delay: ${delayStartTime + index * delaySpace}s;` : ''}"` : ''}>${letter}</span>`
            index ++
          }
        }
      })
    })
    $(target).html(newText)
  },

  //小數點後第N位四捨五入
  formatFloat(num, pos){
    var size = Math.pow(10, pos);
    return Math.round(num * size) / size;
  },

  //判斷Swiper輪播數量
  getSlidesCount(swiper) {
    const container = swiper.$el
    const slidesCount = function () {
      if (swiper.loopedSlides) {
        return swiper.slides.length - swiper.loopedSlides * 2
      }
      else {
        return swiper.slides.length
      }
    }
    if (slidesCount() <= swiper.params.slidesPerView) {
      container.addClass('swiper-no-swiping')
      $(swiper.params.navigation.nextEl).hide()
      $(swiper.params.navigation.prevEl).hide()
      $(swiper.params.pagination.el).hide()
      swiper.params.autoplay.enabled = false
      swiper.autoplay.stop()
    }
    else {
      container.removeClass('swiper-no-swiping')
      $(swiper.params.navigation.nextEl).show()
      $(swiper.params.navigation.prevEl).show()
      $(swiper.params.pagination.el).show()
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start()
      }
    }
  },

  //判斷當前輪播是否為影片
  isVideo(swiper) {
    const container = swiper.$el
    const activeSlide = container.find('.swiper-slide-active')
    const video = $(activeSlide).find('video').get(0)
    const allVideo = container.find('.swiper-slide video')
    swiper.autoplay.stop();
    $(video).unbind('ended')
    if (video) {
      allVideo.each(function (index, el) {
        el.currentTime = 0
      })
      $(video).on('ended', function () {
        swiper.slideNext()
      })
      video.play()
    }
    else {
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start()
      }
    }
  },

  gradientAnimate(target, posX, storage, speed) {
    const add = speed || .5
    posX = posX < 200 ? posX + add : 0
    target.style.backgroundPositionX = `${posX}%`

    storage = requestAnimationFrame(() => {
      methods.gradientAnimate(target, posX)
    })
  },

  resize(fun) {
    let resize = false;
    let t;
    let doResize = fun;

    $(window).on('resize', function () {
      resize = true;
      clearTimeout(t);
      // console.log('resize')
      t = setTimeout(doResize, 500);
    });
  }
}